<div class="composite-tile-container flex flex-col border-solid border-1 border-sky-blue rounded-[18px] bg-white"
    [ngClass]="isPestLaborProductivityDivisionMode ? 'md:w-[42rem] xl:min-w-[48rem]' : 'md:w-80 xl:min-w-96'">
    <div class="composite-tile-header flex gap-3 justify-start items-center px-6 py-4 min-h-10 neptune-border-b-1 border-sky-blue">
        <img  *ngIf="id | eroi:'metricIcon' as icon" [src]="icon" class="w-9 h-9" alt="tvd-metric-icon">
        <span class="flex items-center text-2xl text-blue min-h-2xl-clamp">{{ id | eroi:'title' }}</span>
    </div>

    <div class="composite-tile-body flex flex-col gap-2 p-6">
        <div class="composite-metric-contributions flex flex-col gap-3">
            <div class="metrics-info flex flex-col gap-4" [ngClass]="{ 'pb-4 neptune-border-b-1 border-sky-blue': isPestLaborProductivityDivisionMode }">
                <span class="text-4xl font-bold"><span class="currency-symbol">{{currencyCode | currencySymbol}}</span><span class="monetary-contribution">{{displayInRoundedNumber ? (displayMonetaryContribution | abbreviateNumber) : displayMonetaryContribution}}</span></span>
                <p class="text-base"><span class="value-contribution font-bold">{{displayValueContribution}}</span>&nbsp;<span class="value-units">{{ id | eroi:'units':{measurementSystem: measurementSystem} }}</span></p>
            </div>

            <div class="view-details-button neptune-button-white flex justify-center items-center px-3 py-2 cursor-pointer" *ngIf="!showInfoTooltip && !makingSelectionsState" (click)="ViewDetailsByLocation()">
                View Details
                <img src="assets/shared-icons/neptune-icon-blue-chevron-right.svg" class="h-5 w-5" alt="arrow-right-icon"/>
            </div>
            <information-tooltip *ngIf="showInfoTooltip && showInEnterpriseTerms && !makingSelectionsState" [toolTipType]="infoTooltipType.LaborProductivityTerms" [isStaticTooltip]="true"/>
        </div>

        <!--
            Composite Tile behaviour - The subcomponents only show when user has selected "Division Terms" or when making presentation selections,
            otherwise only the parent component (the Enterprise term) is visible
         -->
        <ng-container *ngIf="!showInEnterpriseTerms || makingSelectionsState">
            <div class="sub-components flex flex-col items-stretch justify-center" [ngClass]="{ 'pest-labor-sub-grid': isPestLaborProductivityDivisionMode }">
                <ng-content></ng-content>
            </div>
        </ng-container>
    </div>
</div>
